import React, { Component } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

//componentes
import "./correosI.css";
import AdjuntarArchivo from "./adjuntararchivosI";
import Alert from "../../modal/alert";

function Correos(props) {
  const [ifechamedi, setifechamedi] = React.useState([]);
  const [listaOn, setlistaOn] = React.useState(false);
  const [mensajealerta, setmensajealerta] = React.useState(false);
  const [correoR, setcorreoR] = React.useState([]);
  const [listaCorreo, setlistaCorreo] = React.useState([]);
  const [flotadorMOn, setflotadorMOn] = React.useState(false);
  const [correoaEnviar, setcorreoaEnviar] = React.useState([]);
  const [iseccion, setiseccion] = React.useState([]);
  const [correoI, setcorreoI] = React.useState("");
  const [flotadorCOn, setflotadorCOn] = React.useState(false);
  const [asuntoOn, setasuntoOn] = React.useState(false);
  const [data, setData] = React.useState({
    correo: "",
    asunto: "",
    cuerpo: "",
  });
  const [tituloM, settituloM] = React.useState("");
  const [cuerpoM, setcuerpoM] = React.useState("");

  const limpiar = () => {
    setmensajealerta(false);
    setcorreoI("");
    setflotadorMOn(false);
    setcorreoaEnviar([]);
    setlistaCorreo([]);
    setcorreoI("");
    setflotadorCOn(false);
    setasuntoOn(false);
    setData({});
  };

  const cerrarLista = () => {
    //console.log(listaOn)
    if (listaOn) {
      setlistaOn(false);
    }
    if (!listaOn) {
      setlistaOn(true);
    }
  };

  const onChange = (e) => {
    let index = e.target.getAttribute("id");
    let data_ = Object.assign({}, data);
    data_[index] = e.target.value;
    setData(data_);
    // if (index === "descripcion") buscarCorreosInternos(e.target.value);
  };

  const onChange4 = (e) => {
    let element = e.target;
    let listaCorreo_ = Array.from(listaCorreo);
    if (element.checked) {
      listaCorreo_.push(element.value);
    } else {
      let pos = listaCorreo_.indexOf(element.value);
      listaCorreo_.splice(pos, 1);
    }
    //console.log({"copia:":listaCorreo_, "global":listaCorreo})
    setlistaCorreo(listaCorreo_);
  };

  const handleClose = () => {
    setmensajealerta(false);
  };

  const buscarCorreosInternos = (e) => {
    let data = new FormData();
    data.append("grado", e);
    data.append("boton", "buscarCorreoInternos");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl = "https://institutobilinguelasnaciones.com/terapias/backend/correos.php";
    axios.post(xurl, data, config).then((res) => {
      let xcorreo = res.data.variable1;

      setcorreoR(xcorreo);
    });
  };

  const buscarCorreosxEnviar = () => {
    let data = new FormData();
    data.append("boton", "buscarCorreoxEnviarI");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl = "https://institutobilinguelasnaciones.com/terapias/backend/correos.php";
    axios.post(xurl, data, config).then((res) => {
      let xcorreo = res.data.variable1;

      setcorreoaEnviar(xcorreo);
    });
  };

    
  const adjuntarArchivo = () => {
    if (flotadorCOn === true) {
      setflotadorCOn(false);
    } else {
      setflotadorCOn(true);
    }
  };

  const enviarCorreo = () => {
    let datax = new FormData();
    datax.append("asunto", data.asunto);
    datax.append("cuerpo", data.cuerpo);
    datax.append("listaCorreo", data.correo);
    datax.append('idespecialista',props.selected.profesor);
    datax.append("boton", "enviarCorreoInterno");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl = "https://institutobilinguelasnaciones.com/terapias/backend/correos.php";
    axios.post(xurl, datax, config).then((res) => {
      //console.log(res.data.variable4);
      //console.log(res.data.variable3);
      if (res.data.variable1) {
        limpiar();
        buscarCorreosxEnviar();

        setmensajealerta(true);
        settituloM("Menu Envio de Correos.");
        cuerpoM("El Correo se Envio Satisfactoriamente.");
      } else {
        setmensajealerta(true);
        settituloM("Menu Envio de Correos.");
        setcuerpoM("Ocurrio un problema, Verifique por favor.");
      }
    });
  };

  

  React.useEffect(() => {
    // buscarSalon();
    buscarCorreosxEnviar();
  }, []);

  return (
    <div className="principal-pago row">
      <div className="contenedor-cxc col-12">
        {mensajealerta === true && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}
        {flotadorCOn === true && (
          <div className="flotadorc">
            <div className="flotadorc1">
              <AdjuntarArchivo
               adjuntarArchivo={adjuntarArchivo} 
               selected={props.selected}
               />
            </div>
          </div>
        )}

        <div className="flotadora">
          <div className="flotadora1">
            <div className="contenedor-titulo row">
              <div className="titulo-pago col-12">
                <p>INGRESE LOS DATOS CORRESPONDIENTES A UN CORREO. </p>
              </div>
              <div className="contenedor-cedula row">
                <div className="contenedorcedula1 col-4">
                  <input
                    className="form-control"
                    type="text"
                    name="correo"
                    id="correo"
                    autoComplete="off"
                    placeholder="Correo a Enviar el Mensaje."
                    maxLength="150"
                    onChange={onChange}
                    value={data.correo.toUpperCase()}
                  />
                </div>
              </div>
              <div className="contenedor-cedula row">
                <div className="contenedorcedula1 col-4">
                  <input
                    className="form-control"
                    type="text"
                    name="asunto"
                    id="asunto"
                    autoComplete="off"
                    placeholder="Asunto del Mensaje."
                    maxLength="100"
                    onChange={onChange}
                    value={data.asunto.toUpperCase()}
                  />
                </div>
              </div>
              <div className="contenedor-cedula row">
                <div className="contenedorcedula1 col-12">
                  <textarea
                    className="form-control"
                    name="cuerpo"
                    id="cuerpo"
                    rows="7"
                    cols="100"
                    placeholder="Cuerpo del Mensaje."
                    onChange={onChange}
                    defaultValue={data.cuerpo.toUpperCase()}
                  />
                </div>
              </div>
              <div className="contenedorcedula1 col-12">
                <button className="boton" onClick={enviarCorreo}>
                  Enviar Correo
                </button>
                <button className="boton" onClick={adjuntarArchivo}>
                  Adjuntar Archivo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(Correos);
